import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { HttpClient } from "@angular/common/http";
import { HttpErrorHandler } from "./http-error-handler";
import { Observable } from "rxjs";
import { NgResponse } from "../shared/ng-response";
import { CaptchaResponse } from "../shared/captcha-response";
import { AppContext } from "../app.context";
import { CaptchaData } from "../shared/captcha-data";

@Injectable()
export class CaptchaService extends HttpClientService {
  constructor(readonly appContext: AppContext,
              readonly httpClient: HttpClient,
              readonly httpErrorHandler: HttpErrorHandler) {
    super('CaptchaService', httpClient, httpErrorHandler);
  }

  init(): Observable<any> {
    return new Observable(observer => {
      this.get<CaptchaData>(
        'captchaData',
        'api/Captcha/CaptchaData')
        .subscribe(ngResponse => {
          this.appContext.captchaData = ngResponse.response;
          observer.next(this);
          observer.complete();
        });
    });
  }

  sendToken(token: string): Observable<NgResponse<CaptchaResponse>> {
    return this.post<CaptchaResponse>('validateToken', `api/Captcha/ValidateToken/${token}`);
  }
}
